// APPLICATIONS:
import add from './icons/application/Add'
import avatarMan from './icons/application/AvatarMan'
import avatarWoman from './icons/application/AvatarWoman'
import bookmark from './icons/application/Bookmark'
import check from './icons/application/Check'
import circle from './icons/application/Circle'
import close from './icons/application/Close'
import dragHandle from './icons/application/DragHandle'
import exportAction from './icons/application/Export'
import eye from './icons/application/Eye'
import eyeClosed from './icons/application/EyeClosed'
import flag from './icons/application/Flag'
import happy from './icons/application/Happy'
import heart from './icons/application/Heart'
import help from './icons/application/Help'
import info from './icons/application/Info'
import linkExternal from './icons/application/LinkExternal'
import link from './icons/application/Link'
import megaphone from './icons/application/Megaphone'
import open from './icons/application/Open'
import people from './icons/application/People'
import refresh from './icons/application/Refresh'
import reorder from './icons/application/Reorder'
import reply from './icons/application/Reply'
import sad from './icons/application/Sad'
import search from './icons/application/Search'
import settings from './icons/application/Settings'
import share from './icons/application/Share'
import spinner from './icons/application/Spinner'
import star from './icons/application/Star'
import start from './icons/application/Start'
import tag from './icons/application/Tag'
import tools from './icons/application/Tools'
import trash from './icons/application/Trash'
import volumeDown from './icons/application/VolumeDown'
import volumeUp from './icons/application/VolumeUp'
import warning from './icons/application/Warning'

// ported from "video" category
import compress from './icons/application/Compress'
import expand from './icons/application/Expand'
import fastForward from './icons/application/FastForward'
import minimize from './icons/application/Minimize'
import pause from './icons/application/Pause'
import playCircle from './icons/application/PlayCircle'
import play from './icons/application/Play'
import rewind from './icons/application/Rewind'
import stepBack from './icons/application/StepBack'
import stepForward from './icons/application/StepForward'
import stop from './icons/application/Stop'

// BRAND:
import android from './icons/brand/Android'
import apple from './icons/brand/Apple'
import facebook from './icons/brand/Facebook'
import github from './icons/brand/Github'
import google from './icons/brand/Google'
import instagram from './icons/brand/Instagram'
import linkedin from './icons/brand/Linkedin'
import medium from './icons/brand/Medium'
import pinterest from './icons/brand/Pinterest'
import reddit from './icons/brand/Reddit'
import skype from './icons/brand/Skype'
import snapchat from './icons/brand/Snapchat'
import tiktok from './icons/brand/Tiktok'
import twitter from './icons/brand/Twitter'
import vimeo from './icons/brand/Vimeo'
import whatsapp from './icons/brand/Whatsapp'
import wordpress from './icons/brand/Wordpress'
import youtube from './icons/brand/Youtube'

// CRYPTO:
import bitcoin from './icons/crypto/Bitcoin'
import bnb from './icons/crypto/Bnb'
import cardano from './icons/crypto/Cardano'
import dogecoin from './icons/crypto/Dogecoin'
import ethereum from './icons/crypto/Ethereum'
import solana from './icons/crypto/Solana'
import tether from './icons/crypto/Tether'
import usdc from './icons/crypto/Usdc'

// CURRENCY:
import dollar from './icons/currency/Dollar'
import euro from './icons/currency/Euro'
import franc from './icons/currency/Franc'
import krona from './icons/currency/Krona'
import lira from './icons/currency/Lira'
import multiCurrency from './icons/currency/MultiCurrency'
import peso from './icons/currency/Peso'
import pound from './icons/currency/Pound'
import ruble from './icons/currency/Ruble'
import rupee from './icons/currency/Rupee'
import shekel from './icons/currency/Shekel'
import won from './icons/currency/Won'
import yen from './icons/currency/Yen'
import yuan from './icons/currency/Yuan'

// DIRECTIONAL:
import arrowDown from './icons/directional/ArrowDown'
import arrowLeft from './icons/directional/ArrowLeft'
import arrowRight from './icons/directional/ArrowRight'
import arrowUp from './icons/directional/ArrowUp'
import caretDown from './icons/directional/CaretDown'
import caretLeft from './icons/directional/CaretLeft'
import caretRight from './icons/directional/CaretRight'
import caretUp from './icons/directional/CaretUp'
import down from './icons/directional/Down'
import left from './icons/directional/Left'
import right from './icons/directional/Right'
import up from './icons/directional/Up'

// FILE:
import downloadCloud from './icons/file/DownloadCloud'
import download from './icons/file/Download'
import fileAudio from './icons/file/FileAudio'
import fileDoc from './icons/file/FileDoc'
import fileImage from './icons/file/FileImage'
import filePdf from './icons/file/FilePdf'
import fileVideo from './icons/file/FileVideo'
import folder from './icons/file/Folder'
import uploadCloud from './icons/file/UploadCloud'
import upload from './icons/file/Upload'
import zip from './icons/file/Zip'

// INPUTS:
import button from './icons/input/Button'
import checkbox from './icons/input/Checkbox'
import color from './icons/input/Color'
import date from './icons/input/Date'
import datetime from './icons/input/Datetime'
import email from './icons/input/Email'
import file from './icons/input/File'
import group from './icons/input/Group'
import hidden from './icons/input/Hidden'
import list from './icons/input/List'
import month from './icons/input/Month'
import number from './icons/input/Number'
import password from './icons/input/Password'
import radio from './icons/input/Radio'
import range from './icons/input/Range'
import repeater from './icons/input/Repeater'
import select from './icons/input/Select'
import submit from './icons/input/Submit'
import telephone from './icons/input/Telephone'
import text from './icons/input/Text'
import textarea from './icons/input/Textarea'
import time from './icons/input/Time'
import url from './icons/input/URL'
import week from './icons/input/Week'

// PAYMENT:
import amex from './icons/payment/Amex'
import discover from './icons/payment/Discover'
import mastercard from './icons/payment/Mastercard'
import paypal from './icons/payment/Paypal'
import stripe from './icons/payment/Stripe'
import visa from './icons/payment/Visa'

export const paymentIcons = {
  amex,
  discover,
  mastercard,
  paypal,
  stripe,
  visa,
}

export const inputIcons = {
  button,
  checkbox,
  color,
  date,
  datetime,
  email,
  file,
  group,
  hidden,
  list,
  month,
  number,
  password,
  radio,
  range,
  repeater,
  select,
  submit,
  telephone,
  text,
  textarea,
  time,
  url,
  week,
}

export const fileIcons = {
  downloadCloud,
  download,
  fileAudio,
  fileDoc,
  fileImage,
  filePdf,
  fileVideo,
  folder,
  uploadCloud,
  upload,
  zip,
}

export const directionalIcons = {
  arrowDown,
  arrowLeft,
  arrowRight,
  arrowUp,
  caretDown,
  caretLeft,
  caretRight,
  caretUp,
  down,
  left,
  right,
  up,
}

export const currencyIcons = {
  dollar,
  euro,
  franc,
  krona,
  lira,
  multiCurrency,
  peso,
  pound,
  ruble,
  rupee,
  shekel,
  won,
  yen,
  yuan,
}

export const cryptoIcons = {
  bitcoin,
  bnb,
  cardano,
  dogecoin,
  ethereum,
  solana,
  tether,
  usdc,
}

export const brandIcons = {
  android,
  apple,
  facebook,
  github,
  google,
  instagram,
  linkedin,
  medium,
  pinterest,
  reddit,
  skype,
  snapchat,
  tiktok,
  twitter,
  vimeo,
  whatsapp,
  wordpress,
  youtube,
}

export const applicationIcons = {
  bitcoin,
  bnb,
  cardano,
  dogecoin,
  ethereum,
  solana,
  tether,
  usdc,
  add,
  avatarMan,
  avatarWoman,
  bookmark,
  check,
  circle,
  close,
  compress,
  dragHandle,
  expand,
  exportAction,
  eye,
  eyeClosed,
  fastForward,
  flag,
  happy,
  heart,
  help,
  info,
  link,
  linkExternal,
  megaphone,
  minimize,
  open,
  pause,
  people,
  play,
  playCircle,
  refresh,
  reorder,
  reply,
  rewind,
  sad,
  search,
  settings,
  share,
  spinner,
  star,
  start,
  stepBack,
  stepForward,
  stop,
  tag,
  tools,
  trash,
  volumeDown,
  volumeUp,
  warning,
}

export const genesisIcons = {
  add,
  arrowDown,
  arrowUp,
  check,
  close,
  checkboxDecorator: check,
  date,
  dragHandle,
  fileItem: fileDoc,
  fileRemove: close,
  noFiles: fileDoc,
  radioDecorator: circle,
  select: down,
  spinner,
  star,
  trash,
  fastForward,
  right,
  left,
  rewind,
  color,
}

export const icons = {
  add,
  amex,
  android,
  apple,
  arrowDown,
  arrowLeft,
  arrowRight,
  arrowUp,
  avatarMan,
  avatarWoman,
  bitcoin,
  bnb,
  bookmark,
  button,
  cardano,
  caretDown,
  caretLeft,
  caretRight,
  caretUp,
  check,
  checkbox,
  circle,
  close,
  color,
  compress,
  date,
  datetime,
  discover,
  dogecoin,
  dollar,
  down,
  download,
  downloadCloud,
  dragHandle,
  email,
  ethereum,
  euro,
  expand,
  exportAction,
  eye,
  eyeClosed,
  facebook,
  fastForward,
  file,
  fileAudio,
  fileDoc,
  fileImage,
  filePdf,
  fileVideo,
  flag,
  folder,
  franc,
  github,
  google,
  group,
  happy,
  heart,
  help,
  hidden,
  info,
  instagram,
  krona,
  left,
  link,
  linkExternal,
  linkedin,
  lira,
  list,
  mastercard,
  medium,
  megaphone,
  minimize,
  month,
  multiCurrency,
  number,
  open,
  password,
  pause,
  paypal,
  people,
  peso,
  pinterest,
  play,
  playCircle,
  pound,
  radio,
  range,
  reddit,
  refresh,
  reorder,
  repeater,
  reply,
  rewind,
  right,
  ruble,
  rupee,
  sad,
  search,
  select,
  settings,
  share,
  shekel,
  skype,
  snapchat,
  solana,
  spinner,
  star,
  start,
  stepBack,
  stepForward,
  stop,
  stripe,
  submit,
  tag,
  telephone,
  tether,
  text,
  textarea,
  tiktok,
  time,
  tools,
  trash,
  twitter,
  up,
  upload,
  uploadCloud,
  url,
  usdc,
  vimeo,
  visa,
  volumeDown,
  volumeUp,
  warning,
  week,
  whatsapp,
  won,
  wordpress,
  yen,
  youtube,
  yuan,
  zip,
}

export {
  add,
  amex,
  android,
  apple,
  arrowDown,
  arrowLeft,
  arrowRight,
  arrowUp,
  avatarMan,
  avatarWoman,
  bitcoin,
  bnb,
  bookmark,
  button,
  cardano,
  caretDown,
  caretLeft,
  caretRight,
  caretUp,
  check,
  checkbox,
  circle,
  close,
  color,
  compress,
  date,
  datetime,
  discover,
  dogecoin,
  dollar,
  down,
  download,
  downloadCloud,
  dragHandle,
  email,
  ethereum,
  euro,
  expand,
  exportAction,
  eye,
  eyeClosed,
  facebook,
  fastForward,
  file,
  fileAudio,
  fileDoc,
  fileImage,
  filePdf,
  fileVideo,
  flag,
  folder,
  franc,
  github,
  google,
  group,
  happy,
  heart,
  help,
  hidden,
  info,
  instagram,
  krona,
  left,
  link,
  linkExternal,
  linkedin,
  lira,
  list,
  mastercard,
  medium,
  megaphone,
  minimize,
  month,
  multiCurrency,
  number,
  open,
  password,
  pause,
  paypal,
  people,
  peso,
  pinterest,
  play,
  playCircle,
  pound,
  radio,
  range,
  reddit,
  refresh,
  reorder,
  repeater,
  reply,
  rewind,
  right,
  ruble,
  rupee,
  sad,
  search,
  select,
  settings,
  share,
  shekel,
  skype,
  snapchat,
  solana,
  spinner,
  star,
  start,
  stepBack,
  stepForward,
  stop,
  stripe,
  submit,
  tag,
  telephone,
  tether,
  text,
  textarea,
  tiktok,
  time,
  tools,
  trash,
  twitter,
  up,
  upload,
  uploadCloud,
  url,
  usdc,
  vimeo,
  visa,
  volumeDown,
  volumeUp,
  warning,
  week,
  whatsapp,
  won,
  wordpress,
  yen,
  youtube,
  yuan,
  zip,
}

export { createIconPlugin } from './plugin'
